import { render, staticRenderFns } from "./new.vue?vue&type=template&id=31e1b50f&scoped=true&"
import script from "./new.js?vue&type=script&lang=js&"
export * from "./new.js?vue&type=script&lang=js&"
import style0 from "./new.vue?vue&type=style&index=0&id=31e1b50f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31e1b50f",
  null
  
)

export default component.exports